export default __webpack_public_path__ + "static/PC_1_3-afc7978593f62b87f3e4d518cb1cada2.png";